module.exports = __webpack_public_path__ + "static/media/1.64a4edaa.jpg";